var __TEMP__ = require('./_hashClear.js');var hashClear = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_hashDelete.js');var hashDelete = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_hashGet.js');var hashGet = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_hashHas.js');var hashHas = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_hashSet.js');var hashSet = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = Hash;
